var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{},[(_vm.$auth.user)?_c('Main'):_c('LoginForm',{attrs:{"errorMessage":_vm.errorMessage},on:{"submit":_vm.login}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }